import { mentalMapConfig } from '@labrain/engine-staircase';
export const staircaseConfig = {
    ...mentalMapConfig,
    // Adaptation MVP : on switch sur n_items (nombre landmarks) plutôt que grid_size.
    variable: 'n_items',
    startValue: 4,
    minValue: 3,
    maxValue: 10,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 16,
    direction: 'down-easier',
};
/** 8 directions cardinales (horloge : 0 = nord, 90 = est, …). */
export const DIRECTION_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];
export const DIRECTION_LABEL = {
    0: 'N',
    45: 'NE',
    90: 'E',
    135: 'SE',
    180: 'S',
    225: 'SO',
    270: 'O',
    315: 'NO',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, gridSize: 6, explorationMs: 8000, label: 'Découverte' };
    }
    if (level <= 20) {
        return { level, gridSize: 7, explorationMs: 6000, label: 'Carte plus dense' };
    }
    if (level <= 30) {
        return { level, gridSize: 8, explorationMs: 5000, label: 'Survey serré' };
    }
    if (level <= 40) {
        return { level, gridSize: 9, explorationMs: 4000, label: 'Mémoire spatiale' };
    }
    return { level, gridSize: 10, explorationMs: 3500, label: 'Cartographe' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** 12 noms de landmarks emoji-friendly. */
export const LANDMARK_TOKENS = [
    '🌳', '🏛', '⛪', '🗼', '🌊', '⛰',
    '🏠', '🌷', '🪨', '🌉', '🏰', '🌲',
];
export const LANDMARK_NAMES = [
    'Arbre', 'Temple', 'Église', 'Tour',
    'Vague', 'Mont', 'Maison', 'Fleur',
    'Pierre', 'Pont', 'Donjon', 'Pin',
];
export const timing = {
    preExplorationMs: 800,
    preTestMs: 500,
    feedbackMs: 700,
    itiMs: 800,
};
export const paradigmMeta = {
    slug: 'mental-map',
    paradigm: 'Cognitive mapping (Tolman 1948 / O\'Keefe & Moser)',
    masterMage: 'Garek (terre-spatial) + Ondine (mémoire)',
    category: 'terre_navigation',
    goal: 'Construire une carte mentale — navigation, sens de l\'orientation IRL.',
};
//# sourceMappingURL=params.js.map